import * as React from 'react';
import * as styles from './styles.css';

import { Select, IconSort16 } from '@cian/ui-kit';

import { ESortFilter } from '../../types/redux/filters';

export interface IOptions {
  label: string;
  value: ESortFilter;
}

export interface ISortFilterProps {
  options: IOptions[];
  activeValue: ESortFilter;
  onChange(sort: ESortFilter): void;
}

export function SortFilter({ options, activeValue, onChange }: ISortFilterProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <IconSort16 color="primary_100" />
      </div>
      <div className={styles['sort-button']}>
        <Select value={activeValue} onChange={onChange} options={options} />
      </div>
    </div>
  );
}
